import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=e18b6dc6"
import script from "./Editor.vue?vue&type=script&lang=js"
export * from "./Editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/test-tripanels/clusterpanels/client-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e18b6dc6')) {
      api.createRecord('e18b6dc6', component.options)
    } else {
      api.reload('e18b6dc6', component.options)
    }
    module.hot.accept("./Editor.vue?vue&type=template&id=e18b6dc6", function () {
      api.rerender('e18b6dc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Editor.vue"
export default component.exports